"use strict";

exports.__esModule = true;
exports.formatDuration = void 0;
var getFormattedDurationInHoursMinutesSeconds = function getFormattedDurationInHoursMinutesSeconds(sign, hours, minutes, seconds) {
  var format = "" + sign;
  if (hours) {
    format += hours + "h ";
  }
  if (minutes) {
    format += minutes + "m ";
  }
  if (seconds) {
    format += seconds + "s";
  }
  return format;
};

/**
 * Format a number of milliseconds as a duration.
 */
var formatDuration = exports.formatDuration = function formatDuration(input, showHoursMinutesSeconds) {
  if (!input) {
    input = 0;
  }
  var sign = input <= -1000 ? "-" : "";
  var roundTowardsZero = input > 0 ? Math.floor : Math.ceil;
  var hours = roundTowardsZero(input / 3600000);
  var minutes = roundTowardsZero(input / 60000) % 60;
  var seconds = roundTowardsZero(input / 1000) % 60;
  if (showHoursMinutesSeconds) {
    return getFormattedDurationInHoursMinutesSeconds(sign, hours, minutes, seconds);
  }
  if (hours) {
    if (!minutes) {
      return "" + sign + hours + "h";
    }
    return "" + sign + hours + "h " + minutes + "m";
  }
  if (minutes) {
    if (seconds) {
      return "" + sign + minutes + "m " + seconds + "s";
    }
    return "" + sign + minutes + "m";
  }
  return "" + sign + seconds + "s";
};